import React, { useState } from "react";
import "./index.css";

interface MapLegendProps {
    i18nMap: any;
}

const LEGEND_ITEMS = [
    { colorKey: "#d42b15", labelKey: "solarExcellent" },
    { colorKey: "#e47a09", labelKey: "solarVeryGood" },
    { colorKey: "#f0b828", labelKey: "solarGood" },
    { colorKey: "#f5e840", labelKey: "solarMedium" },
    { colorKey: "#5176c8", labelKey: "solarLow" },
];

export const MapLegend: React.FC<MapLegendProps> = ({ i18nMap }) => {
    const [collapsed, setCollapsed] = useState(true);

    return (
        <div className={`map-legend ${collapsed ? 'map-legend--collapsed' : 'map-legend--expanded'}`}>
            <div className="map-legend-header" onClick={() => setCollapsed(!collapsed)}>
                <span className="map-legend-title">{i18nMap.solarSuitability}</span>
                <span className="map-legend-toggle">{collapsed ? "▼" : "▲"}</span>
            </div>
            <div className="map-legend-items-wrapper">
                <div className="map-legend-items">
                    {LEGEND_ITEMS.map((item) => (
                        <div className="map-legend-item" key={item.labelKey}>
                            <span
                                className="map-legend-color"
                                style={{ backgroundColor: item.colorKey }}
                            />
                            <span className="map-legend-label">{i18nMap[item.labelKey]}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
